<template>
  <div class="contador-ger">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <div class="cabecalho">
        <App-Filtros
        :cpntMontarCampoF="contadorGerTabOnBuscarOptionsFiltroF"
        :cpntMontarCampoO="contadorGerTabOnBuscarOptionsFiltroO"
        :cpntMontarCampoV="contadorGerTabOnBuscarOptionsFiltroV"
        :cpntFiltroPredefinido="{ f: 'nome', o: '%', v: '' }"

        :cpntInputCoringa="{}"
        :cpntApiTabPer="tabper"
        @BUSCAR='contadorGerTabBuscarLinhas'
        ref="filtros">
        <div class="botao" v-if="$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 36 ], null, null, null, null, null, false) === true">
          <App-Button :data-time="time" :cpntClass="[ 'btn', 'btn-info' ]" @onClick='contadorGerNovoCNPJ'>Novo CNPJ</App-Button>
        </div>
        </App-Filtros>
      </div>

      <!-- SETA A TABELA -->
      <div class="tabela">
        <App-Tabela
        :cpntSetarFiltros="contadorGerTabSetarFiltros"
        :cpntMontarFiltros="contadorGerTabMontarFiltros"
        :cpntMontarWhere="contadorGerTabTabelaMontarWhere"
        :cpntColuna="colunas"
        :cpntLinha="linha"
        :cpntMostrarMper="true"
        :cpntSetarValores="contadorGerTabSetarLinhas"
        :cpntApiTabPer="tabper"
        :cpntApiTabPerOrder="tabPerOrder"
        :cpntSalvarEdicao="contadorGerTabEditar"
        :cpntApiRouter="route"
        :cpntApiWhere="where"
        :cpntApiMethods="'POST'"
        :cpntApiEstruturaQueryGet="estruturaQueryGet"
        ref="tabela">
          <!-- LOGOTIPO -->
          <template v-slot:col_logo="{ linha }">
            <img :src="linha.logo" :title="linha.clu + ' - ' + linha.cliente" />
          </template>

          <!-- NOME DA EMPRESA -->
          <template v-slot:col_nome="{ linha }">
            <span v-html="linha.cliente"></span>
            <br/>
            <span v-html="linha.cnpj"></span>
          </template>

          <!-- REPRESENTANTE LEGAL -->
          <template v-slot:col_representante="{ linha }">
            <span v-html="linha.rep_leg"></span>
            <br/>
            <span v-html="linha.rep_cpf"></span>
          </template>

          <!-- COLUNA EMAIL -->
          <template v-slot:col_email="{ valor }">
            <span v-if="[ '', null, undefined ].indexOf(valor) === -1" v-html='valor.split(";").join("<br/>")'></span>
          </template>

          <!-- COLUNA EMAIL FISCAL -->
          <template v-slot:col_email_fiscal="{ valor }">
            <b v-if="[ '', null, undefined ].indexOf(valor) === -1" v-html='valor.split(";").join("<br/>")'></b>
          </template>

          <!-- COLUNA EMAIL -->
          <template v-slot:col_cep="{ valor }">
            <span v-html="contadorGerTabFormatarCep(valor)"></span>
          </template>

          <!-- COLUNA SITE -->
          <template v-slot:col_site="{ valor }">
            <a v-if="[ '', null, undefined ].indexOf(valor) === -1" :href='valor' target="_blank" class="btn btn-default bt-link-cadastro" v-html="valor"></a>
          </template>

          <!-- COLUNA OPTANTE PELO SIMPLES -->
          <template v-slot:col_rt_id="{ linha }">
            <span v-if="linha.rt_id === '1'">Simples Nacional</span>
            <span v-else-if="linha.rt_id === '2'">Simples Nacional – excesso de sublimite de receita bruta</span>
            <span v-else-if="linha.rt_id === '3'">
              Regime Normal
              <br/>
              Lucro {{ linha.rt_3_opt === 'p' ? 'Presumido' : 'Real' }}
            </span>
          </template>

          <template v-slot:col_endereco="{ linha }">
            <span v-html='linha.endereco'></span>
            <span v-html='" , "'></span>
            <span v-html='linha.numero'></span>
            <span v-html='" ( " + linha.complemento + ")"'></span>
          </template>

          <!-- REPRESENTANTE LEGAL -->
          <template v-slot:col_contrato="{ linha }">
            <template v-if="[ '34' ].indexOf(linha.id_pac) !== -1">
              Free
            </template>
            <template v-else-if="[ '36' ].indexOf(linha.id_pac) !== -1">
              Plus
            </template>
          </template>

          <template v-slot:col_habilitada="{ linha }">
            <!-- BLOQUEADO -->
            <template v-if="linha.habilitada === '0'">
              <App-Icone v-if="linha.data_blok_diff <= -90"
              :cpntTipo="'alerta-vermelho'"
              :cpntExplica='{ mensagem: "<b>Cancelado</b>, através de bloqueio desde o dia " + linha.data_blok, posicaoMy: "top right", posicaoAt: "bottom left" }'
              ></App-Icone>

              <App-Icone v-else-if="linha.data_blok_diff <= 0"
              :cpntTipo="'alerta-vermelho'"
              :cpntExplica='{ mensagem: "Bloqueado desde o dia " + linha.data_blok, posicaoMy: "top right", posicaoAt: "bottom left" }'
              ></App-Icone>

              <App-Icone v-else
              :cpntTipo="'alerta-amarelo'"
              :cpntExplica='{ mensagem: "Bloquear a partir do dia " + linha.data_blok + ", o cliente ainda tem " + linha.data_blok_diff + " para utilizar.", posicaoMy: "top right", posicaoAt: "bottom left" }'
              ></App-Icone>

              <!-- <App-Icones v-if="linha.data_blok_diff <= -90"
              :cpntIcone='"alerta"' 
              :cpntIconeClass='"rf-icon-vermelho"'
              ></App-Icones> -->

              <!-- <App-Icones v-else-if="linha.data_blok_diff <= 0"
              :cpntIcone='"alerta"' 
              :cpntIconeClass='"rf-icon-vermelho"'
              :cpntExplica='{ mensagem: "Bloqueado desde o dia " + linha.data_blok, posicaoMy: "top right", posicaoAt: "bottom left" }'
              ></App-Icones> -->

              <!-- <App-Icones v-else
              :cpntIcone='"alerta"' 
              :cpntIconeClass='"rf-icon-amarelo"'
              :cpntExplica='{ mensagem: "Bloquear a partir do dia " + linha.data_blok + ", o cliente ainda tem " + linha.data_blok_diff + " para utilizar.", posicaoMy: "top right", posicaoAt: "bottom left" }'
              ></App-Icones> -->
            </template>

            <!-- CANCELADO -->
            <App-Icone v-else-if="linha.habilitada === '2'"
            :cpntTipo="'check-vermelho'"
            :cpntExplica='{ mensagem: "Licença de uso <b>Cancelada</b>", posicaoMy: "top right", posicaoAt: "bottom left" }'
            ></App-Icone>
            <!-- <App-Icones v-else-if="linha.habilitada === '2'"
            :cpntIcone='"erro"' 
            :cpntIconeClass='"rf-icon-vermelho"'
            :cpntExplica='{ mensagem: "Licença de uso <b>Cancelada</b>", posicaoMy: "top right", posicaoAt: "bottom left" }'
            ></App-Icones> -->

            <!-- HABILITADO -->
            <App-Icone v-else
            :cpntTipo="'check-verde'"
            ></App-Icone>
            <!-- <App-Icones v-else
            :cpntIcone='"check-circulo"' 
            :cpntIconeClass='"rf-icon-verde"'
            ></App-Icones> -->
          </template>

          <!-- REPRESENTANTE LEGAL -->
          <template v-slot:col_certificado="{ linha }">
            <template v-if="[ '', null, undefined ].indexOf(linha.certificado) !== -1">
              ---
            </template>
            <template v-else>
              <!-- ICONE DE ERRO -->
              <App-Icones v-if="linha.certificado_diff <= 0"
              :cpntIcone='"erro"' 
              :cpntIconeClass='"rf-icon-vermelho"'
              :cpntExplica='{ mensagem: "VENCIDO há " + (linha.certificado_diff * (-1)) + " dia(s).", posicaoMy: "top right", posicaoAt: "bottom left" }'
              ></App-Icones>

              <!-- ICONE DE ATENÇÃO -->
              <App-Icones v-else-if="linha.certificado_diff <= 30"
              :cpntIcone='"alerta"' 
              :cpntIconeClass='"rf-icon-amarelo"'
              :cpntExplica='{ mensagem: "Certificado vence em " + linha.certificado + " totalizando " + linha.certificado_diff + " dias.<br/>", posicaoMy: "top right", posicaoAt: "bottom left" }'
              ></App-Icones>

              <!-- ICONE DE ATENÇÃO -->
              <App-Icones v-else
              :cpntIcone='"check-circulo"' 
              :cpntIconeClass='"rf-icon-verde"'
              ></App-Icones>

              <!-- SETA A DATA DO CERTIFICADO -->
              <span v-html="linha.certificado"></span>
            </template>
          </template>

          <template v-slot:col_acao="{ linha }">
            <RF-Button style="margin: 2px 0px;" v-if="(linha.habilitada === '1' || linha.habilitada === '0') && $store.state.token.usuario !== 'SuporteRF'"
            :cpntId='campos.botao_conectar.id'
            :cpntStatus='campos.botao_conectar.status' 
            :cpntTexto='campos.botao_conectar.texto'
            :cpntTipo='campos.botao_conectar.tipo'
            :cpntIcone='campos.botao_conectar.icone'
            :cpntClass='campos.botao_conectar.class'
            @onClickButton='() => { campos.botao_conectar.onClick(linha.clu, linha) }'>
            </RF-Button>

            <App-Button cpntClass="btn btn-primary btn-sm" style="margin: 2px 0px;" v-else-if="linha.habilitada === '2' && $store.state.token.usuario !== 'SuporteRF'" @onClick="() => { contadorGerTabOnDialogReativarConta(linha) }">
              Reativar
            </App-Button>

            <App-Button cpntClass="btn btn-danger btn-sm" style="margin: 2px 0px;" v-else-if="linha.habilitada !== '2' && $store.state.token.usuario === 'SuporteRF' && linha.id_pac === '36'" @onClick="() => { contadorGerTabOnRemoverConta(linha.clu) }">
              <!-- SETA O ICONE -->
              <App-Icone :cpntTipo="'lixeira'"></App-Icone>

              <!-- SETA O NOME -->
              Remover
            </App-Button>
          </template>

          <template v-slot:editar_celula="vetor">
            <!-- CHAMA A FUNÇÃO PARA CARREGAR OS DADOS -->
            <template v-if="campoEditar.tipo === '' || (campoEditar.hash !== vetor.hash)">
              <!-- EXECUTA A FUNÇÃO PARA MONTAR O CAMPO -->
              {{ contadorGerTabIniciarEdicaoCampo(vetor) }}

              <!-- SETA O STATUS DO CAMPO -->
              <App-Status-2 :cpntStatus='"carregando"' ></App-Status-2>
            </template>

            <!-- SETA O CAMPO INPUT -->
            <App-Input :data-time="time" v-else-if='campoEditar.tipo === "input"'
              :cpntStatus='campoEditar.status'
              :cpntId='campoEditar.id'
              :cpntTabIndex='campoEditar.tabIndex'
              :cpntNome='campoEditar.nome'
              :cpntValue='campoEditar.value'
              :cpntMensagem='campoEditar.mensagem'
              :cpntDisabled='campoEditar.disabled'
              :cpntMostrar='campoEditar.mostrar'
              :cpntExplica='campoEditar.explica'
              :cpntPlaceholder='campoEditar.placeholder'
              :cpntValueRef='campoEditar.valueRef'
              :cpntRouter='campoEditar.router'
              :cpntMethod='campoEditar.method'
              :cpntField='campoEditar.field'
              :cpntWhere='campoEditar.where'
              :cpntAddButForm='campoEditar.addButForm'
              :cpntKeyMostra='campoEditar.keyMostra'
              :cpntTipoOrder='campoEditar.tipoOrder'
              :cpntOrder='campoEditar.order'
              :cpntOptions='campoEditar.options'
              :cpntKeyValue='campoEditar.keyValue'
              :cpntSearchMinimo='campoEditar.searchMinimo'
              :cpntMask='campoEditar.mask'

              :cpntOnChange='campoEditar.onChange'
              :cpntOnBlur='campoEditar.onBlur'
              :cpntOnRealizaBusca='campoEditar.onRealizaBusca'
              :cpntOnKeyPressEnter='vetor.salvar'
              :ref="campoEditar.id"
            ></App-Input>
          </template>
        </App-Tabela>
      </div>
    </template>

    <!-- LOCAL AONDE SERÁ ABERTO O FORMULARIO -->
    <router-view :cpntFecharFormulario="contadorGerTabFecharFormulario"></router-view>

    <RF-Dialog v-if="novoCNPJ === true"
    :cpntLargura='"450px"'
    :cpntOnFecharDialog='contadorGerNovoCNPJ'>
    <template slot='titulo'>
      <!-- SETA O ICONE DO CAMPO -->
      <i aria-hidden="true" class="fa fa-angle-double-right"></i>

      <!-- SETA O TITULO DA ABA -->
      <template v-if="dialogReativar === ''">
        Cadastro Novo CNPJ
      </template>
      <template v-else>
        Reativar CLU {{ dialogReativar }}
      </template>
    </template>
    
    <template slot='conteudo'>
      <div class="con-ger-nov-cnpj">
        <template v-if="dialogReativar === ''">
          CNPJ: 
          <!-- SETA O CAMPO DO CNPJ -->
          <App-Input :data-time="time" class="con-ger-tab--cnpj" 
          :cpntStatus='campos.cnpj.status'
          :cpntId='campos.cnpj.id'
          :class='campos.cnpj.class'
          :cpntTabIndex='campos.cnpj.tabIndex'
          :cpntClassDivField='campos.cnpj.classDivField'
          :cpntNome='campos.cnpj.nome'
          :cpntValue='campos.cnpj.value'
          :cpntAutoComplete='campos.cnpj.autocomplete'
          :cpntMask='campos.cnpj.mask'
          :cpntOptionInicialNome='campos.cnpj.optionInicialNome'
          :cpntOptionInicialValue='campos.cnpj.optionInicialValue'
          :cpntDisabled='campos.cnpj.disabled'
          :cpntMostrar='campos.cnpj.mostrar'
          :cpntAutoFocus='campos.cnpj.autofocus'
          :cpntMensagem='campos.cnpj.mensagem'
          :cpntMensagemTipo='campos.cnpj.mensagemTipo'
          :cpntPlaceholder='campos.cnpj.placeholder'
          :cpntPosicionar='campos.cnpj.posicionar'
          :cpntOnChange='campos.cnpj.onChange'
          :cpntOnBlur='campos.cnpj.onBlur'
          ref='cnpj'
          ></App-Input>
        </template>

        <div class="aviso-senha">
          <!-- SETA O ICONE -->
          <App-Icone :cpntTipo="'alerta-amarelo'"></App-Icone>

          <!-- SETA A FRASE -->
          Informe a senha do seu usuário [ <b v-html="$store.state.token.usuario"></b> ]:

          <!-- SETA O CAMPO SENHA -->
          <App-Input :data-time="time" class="con-ger-tab--senha" 
          :cpntStatus='campos.senha.status'
          :cpntId='campos.senha.id'
          :cpntType='campos.senha.type'
          :class='campos.senha.class'
          :cpntTabIndex='campos.senha.tabIndex'
          :cpntClassDivField='campos.senha.classDivField'
          :cpntNome='campos.senha.nome'
          :cpntValue='campos.senha.value'
          :cpntAutoComplete='campos.senha.autocomplete'
          :cpntMask='campos.senha.mask'
          :cpntOptionInicialNome='campos.senha.optionInicialNome'
          :cpntOptionInicialValue='campos.senha.optionInicialValue'
          :cpntDisabled='campos.senha.disabled'
          :cpntMostrar='campos.senha.mostrar'
          :cpntAutoFocus='campos.senha.autofocus'
          :cpntMensagem='campos.senha.mensagem'
          :cpntMensagemTipo='campos.senha.mensagemTipo'
          :cpntPlaceholder='campos.senha.placeholder'
          :cpntPosicionar='campos.senha.posicionar'
          :cpntOnChange='campos.senha.onChange'
          :cpntOnBlur='campos.senha.onBlur'
          ref='senha'
          ></App-Input>
        </div>

        <!-- ({{ pac36 }})
        ({{ $store.state.token.clu_con }}) -->
        <!-- ({{ [ 'l', 'lv' ].indexOf($store.state.token.clu_con) !== -1 }})
        ({{ pac36.contratado === 's' }}) -->
        <!-- ({{ pac36 }}) -->
        <div class="aviso-cadastro" v-if="([ 'l', 'lv' ].indexOf($store.state.token.clu_con) !== -1 && pac36.contratado === 's')">
          Prezado Cliente, a inclusão deste CNPJ criará um chamado e acrescentará o valor de uma licença de uso mensal do contador plus a partir da sua próxima fatura.
          <br/>
          <br/>
          Não será possível remover esta licença de uso pelo período de 30 dias corridos.
          <br/>
          <br/>
          Após clicar em Aceito, inserir! Esse novo CNPJ já estará disponível para utilização.
        </div>

        <!-- SETA O BOTÃO DO CADASTRO -->
        <App-Button :data-time="time" :cpntStatus="novoCNPJStatus" :cpntClass="[ 'btn', 'btn-primary' ]" @onClick='() => { contadorGerGerarCadastro() }'>Aceito, inserir!</App-Button>
      </div>
    </template>
    </RF-Dialog>

    <RF-Dialog v-if="dialogNovoCNPJ !== ''"
    :cpntLargura='"500px"'
    :cpntOnFecharDialog='contadorGerNovoCNPJ'>
    <template slot='titulo'>
      <!-- SETA O ICONE DO CAMPO -->
      <i aria-hidden="true" class="fa fa-angle-double-right"></i>

      <!-- SETA O TITULO DA ABA -->
      Confirmação de Novo CNPJ
    </template>
    
    <template slot='conteudo'>
      <div class="con-ger-avi-nov-cnpj">
        <!-- SETA A MENSAGEM RECEBIDA DA API -->
        <div v-html="dialogNovoCNPJ"></div>
        
        <br/>
        
        <!-- SETA A FRASE -->
        <div>Qual ação deseja realizar?</div>
        
        <br/>

        <!-- SETA OS BOTOES -->
        <div>
          <!-- SETA O BOTÃO PARA CRIAR UMA NOVA -->
          <App-Button :cpntClass="'btn btn-primary'" :data-time="time" @onClick='() => { contadorGerGerarCadastro("s") }'>Criar uma nova Licença de Uso</App-Button>
          
          <!-- SETA O BOTÃO PARA REATIVAR LICENÇAS -->
          <App-Button :cpntClass="'btn btn-warning'" :data-time="time" @onClick="contadorGerAbrirFiltros('reativar')">Reativar uma Licença de Uso</App-Button>
        </div>
      </div>
    </template>
    </RF-Dialog>
  </div>
</template>

<style scoped>
</style>

<style>
.contador-ger > .tabela > table > tbody > tr > td.col_clu {
  width: 80px;
}
.contador-ger > .tabela > table > tbody > tr > td.col_logo {
  width: 110px;
}
  .contador-ger > .tabela > table > tbody > tr > td.col_logo > div > span > img {
    max-width: 100px;
    max-height: 45px;
  }

  .contador-ger > .tabela > table > tbody > tr > td.col_habilitada > div > span > .cpnt-icone > img {
    width: 25px;
    height: 25px;
  }
.contador-ger > .tabela > table > tbody > tr > td.col_certificado {
  width: 130px;
}
  .contador-ger > .tabela > table > tbody > tr > td.col_certificado > div > span > .rf-icone {
    display: block;
    margin-top: 3px;
    margin-bottom: 3px;
  }

/* .contador-ger > .tabela > table > tbody > tr > td.col_pacotes > div > span > button {
    padding: 3px 5px;
  }
  .contador-ger > .tabela > table > tbody > tr > td.col_pacotes > div > span > button > span > svg {
    font-size: 18px;
    opacity: 0.70;
  } */

.contador-ger > .tabela > table > tbody > tr > td.col_acao {
  width: 100px;
}
  .contador-ger > .tabela > table > tbody > tr > td.col_acao > div > span > button {
    width: 100%;
  }

.con-ger-nov-cnpj {
  text-align: center;
}
  .con-ger-nov-cnpj > div.cpnt-app-input {
    margin: 0px auto;
    margin-top: 10px;
    width: 160px;
    /* display: block; */
    vertical-align: 0px;
  }
  .con-ger-nov-cnpj > button {
    margin-top: 10px;
  }
  .con-ger-nov-cnpj > .aviso-cadastro {
    margin-top: 10px;
    padding: 10px 5px;
    border: 2px solid #ff0000;
  }
  .con-ger-nov-cnpj > .aviso-senha {
    margin-top: 10px;
    padding: 10px 5px;
    border: 2px solid #cecc00;
  }
    .con-ger-nov-cnpj > .aviso-senha > .cpnt-app-input {
      vertical-align: -1px;
      width: 130px;
    }

  .con-ger-avi-nov-cnpj {
    text-align: center;
    font-size: calc(100% + 1px);
  }
  .con-ger-avi-nov-cnpj > div > button {
    margin: 5px;
  }
</style>

<script>
  // IMPORTA BIBLIOTECA DEPENDENTE
  var moment = require('moment')

  export default {
    components: {
      'App-Status-2': () => import('@/components/rf-geral/status/RF-Status-2.vue'),
      'App-Filtros': () => import('@/components/_geral/Filtros.vue'),
      'App-Icones': () => import('@/components/rf-geral/icones/RF-Icones.vue'),
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        checkbox: [],
        tabper: 'Contador',
        route: '/contador/get',
        colunas: [],
        linha: [],
        tabPerOrder: [
          { id: '0', nome: 'CLU Crescente',    chave: 'clu',          order: 'asc' },
          { id: '1', nome: 'Ordem Alfabética', chave: 'cliente',      order: 'asc' },
          { id: '2', nome: 'CLU Decrescente',  chave: 'clu',          order: 'desc' },
        ],  
        // where: { aAnd: [ { f: 'status', o: '=', v: '1' } ] },
        // where: {},
        where: { aAnd: [ { m: 'cliente_rotinafacil', f: 'habilitada', o: '<>', v: '2' } ] },
        estruturaQueryGet: [
          [ 'type', 'countAll', 'limit', 'field', 'where', 'order' ]
        ],
        campos: {
          botao_certificado: {
            status: '',
            tipo: 'icone',
            class: 'btn btn-sm btn-default',
            mostrar: true,
            onClick: this.contadorGerTabBotaoAcao
          },
          botao_conectar: {
            status: '',
            tipo: 'texto',
            texto: 'Conectar',
            class: 'btn btn-sm btn-primary',
            mostrar: true,
            onClick: this.contadorGerTabConectarClu
          },
          cnpj: {
            status: '',
            class: '',
            nome: '',
            value: '',
            valueIni: '',
            mask: 'cnpj',
            onChange: (value) => {
              // SETA O VALOR RECEBIDO
              this.$set(this.campos.cnpj, 'value', value)

              // LIMPA O CAMPO DE MENSAGEM DE ERRO
              this.$set(this.campos.cnpj, 'mensagem', '')

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            }
          },
          senha: {
            status: '',
            class: '',
            type: 'password',
            nome: '',
            value: '',
            valueIni: '',
            onChange: (value) => {
              // SETA O VALOR RECEBIDO
              this.$set(this.campos.senha, 'value', value)

              // LIMPA O CAMPO DE MENSAGEM DE ERRO
              this.$set(this.campos.senha, 'mensagem', '')

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            }
          }
        },
        campoEditar: {
          id: '',
          hash: '',
          tipo: '',
          status: '',
          nome: '',
          keyValue: 'id',
          keyMostra: [ 'nome' ],
          options: [],
          optionInicialNome: '',
          value: '',
          mostrar: true,
          searchMinimo: 4,
          onBuscarOptions: null,
          onChange: this.contadorGerTabIniciarEdicaoOnChangeValue,
          onKeyPressEnter: null
        },
        dialogReativar: '',
        novoCNPJ: false,
        novoCNPJStatus: '',
        dialogNovoCNPJ: '',
        pac36: null
      }
    },
    mounted: function () {
      // SETA O STATUS DA PAGINA
      this.contadorGerTabSetarStatusGeral('carregando')
      
      // INICIA O CARREGAMENTO DA TELA
      this.contadorGerTabVerificarContratacaoPacote(this.contadorGerTabBuscarLinhas)
    },
    destroyed: function () {
      $('.qtip-cpnt-tab-contador-ger').qtip('destroy')
    },
    methods: {
      // 03/01/2022 - 10:38
      // A PEDIDO DO RAPHAEL, FOI CRIADO ESSA VERIFICAÇÃO, PARA VERIFICAR SE O 
      // PACOTE ESTÁ CONTRATADO OU NÃO PARA MOSTRAR A MENSAGEM VERMELHA
      contadorGerTabVerificarContratacaoPacote: function (callback = null) {
        this.$store.state.comunicaAPI('/subase/pacote/get', 'GET', null, (retorno) => {
          // PEGA O PACOTE 36 SE ELE EXISTIR
          this.pac36 = retorno.data.filter(item => item.pac_id === '36')

          // PEGA O PACOTE DESEJADO
          if (this.pac36.length >= 1) {
            this.pac36 = this.pac36[0]
          }
          
          // EXECUTA O CALLBACK RECEBIDO
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        }, this.contadorGerTabSetarStatusGeral) 
      },
      contadorGerTabFecharFormulario: function (atualizar) {
        if (atualizar === true) {
          this.contadorGerTabBuscarLinhas()
        }
      },
      contadorGerTabBuscarLinhas: function () {
        this.contadorGerTabMontarFiltros((filtro = []) => {
          // SETA AS COLUNAS DA TABELA
          var colunas = [
            { mPer: 1,    chave: 'logo',              nome: 'Logotipo',                                                   },
            { mPer: 2,    chave: 'clu',               nome: 'CLU',                                                        },
            { mPer: 2,    chave: 'nome',              nome: 'Empresa (CNPJ)',                                             },
            { mPer: 1,    chave: 'representante',     nome: 'Representante (CPF)',                                        },
            // { mPer: 1,    chave: 'email',             nome: 'E-mail',                                                     },
            { mPer: 0,    chave: 'site',              nome: 'Site',                                                       },
            { mPer: 1,    chave: 'rt_id',             nome: 'Regime tributário'                                           },
            { mPer: 0,    chave: 'cep',               nome: 'CEP',                                                        },
            { mPer: 0,    chave: 'endereco',          nome: 'Endereço',                                                   },
            { mPer: 0,    chave: 'bairro',            nome: 'Bairro',                                                     },
            { mPer: 1,    chave: 'id_cidade_cidade',  nome: 'Cidade',                                                     },
            { mPer: 1,    chave: 'id_estado_estado',  nome: 'Estado',                                                     },
            { mPer: 1,    chave: 'email_fiscal',      nome: 'E-mail Fiscal',       acao: () => { return true }, explica: { mensagem: 'Este é o e-mail utilizado para envio mensal das notas fiscais do Cliente.<br/>Para mais de um e-mail utilize ; (ponto e virgula)' }            },
            { mPer: 1,    chave: 'habilitada',        nome: 'Habilitada'                                                  },
            { mPer: 1,    chave: 'contrato',          nome: 'Contrato'                                                  },
            // { mPer: 1,    chave: 'pacotes',           nome: 'Pacotes'                                                     },
            { mPer: 2,    chave: 'certificado',       nome: 'Certificado',                                                },
            { mPer: 2,    chave: 'acao',              nome: 'Ação',                                                       }
          ]
  
          // SETA OS CAMPOS QUE DEVE BUSCAR
          colunas[0].fieldsApi = {
            clu_dependente: {
              j: {
                clu: { a: 'clu' },
                cod_img: { a: 'cod_img' },
                v_img: { a: 'v_img' },
                cliente: { a: 'cliente' },
                cnpj: { a: 'cnpj' },
                rep_leg: { a: 'rep_leg' },
                rep_cpf: { a: 'rep_cpf' },
                cda1_val: { a: 'cda1_val' },
                habilitada: { a: 'habilitada' },
                data_blok: { a: 'data_blok' },
                rt_id: { a: 'rt_id' },
                rt_3_opt: { a: 'rt_3_opt' },
                email: { a: 'email' },
                site: { a: 'site' },
                cep: { a: 'cep' },
                endereco: { a: 'endereco' },
                numero: { a: 'numero' },
                complemento: { a: 'complemento' },
                bairro: { a: 'bairro' },
                id_cidade: { a: 'id_cidade', j: { cidade: { a: 'id_cidade_cidade' } } },
                id_estado: { a: 'id_estado', j: { estado: { a: 'id_estado_estado' } } },
              }
            },
            id_pac: null,
            email_fiscal: null
          }
  
          // SETA AS COLUNAS MONTADAS
          this.colunas = colunas

          // VERIFICA O WHERE QUE DEVE REALIZAR
          if (filtro.length === 0 || filtro.filter(item => item.f === 'habilitada').length === 0) {
            this.where = { aAnd: [ { m: 'cliente_rotinafacil', f: 'habilitada', o: '<>', v: '2' } ] }
          } else {
            this.where = {}
          }
  
          // VERIFICA SE TEM QUE BUSCAR E ATUALIZAR A TABELA       
          if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 || this.statusGeral === '') {
            this.contadorGerTabReiniciar()
          } else {
            this.contadorGerTabSetarStatusGeral('')
          }
        }, 0, true)
      },
      contadorGerTabTabelaMontarWhere: function (where) {
        // INICIA A VARIAVEL DE RETORNO
        var retorno = {}

        // CONVERTE O VALOR RECEBIDO
        if (where.o === '%') {
          where.o = 'like'
        }

        // VERIFICA SE DEVE SETAR ALGUM VALOR
        switch (where.f) {
          case 'nome':
            retorno.where = { aOr: [
              { m: 'cliente_rotinafacil', f: 'cliente', o: where.o, v: where.v },
              { m: 'cliente_rotinafacil', f: 'rep_leg', o: where.o, v: where.v }
            ] }
            break

          case 'cpf':
            retorno.where = { m: 'cliente_rotinafacil', f: 'rep_cpf', o: where.o, v: where.v }
            break

          case 'email':
            retorno.where = { m: 'cliente_rotinafacil', f: 'email', o: where.o, v: where.v }
            break

          case 'cidade':
            retorno.where = { m: 'cliente_rotinafacil', f: 'id_cidade', o: where.o, v: where.v }
            break

          case 'estado':
            retorno.where = { m: 'cliente_rotinafacil', f: 'id_estado', o: where.o, v: where.v }
            break

          case 'busca':
            retorno.where = { aOr: [ { m: 'cliente_rotinafacil', o: 's.ft', v: where.v } ] }
            break

          case 'regime':
            retorno.where = { m: 'cliente_rotinafacil', f: 'rt_id', o: where.o, v: where.v }
            break

          case 'contador':
            retorno.where = {
              m: 'cliente_rotinafacil',
              f: 'clu',
              r: 'clu_principal',
              o: (where.v === 's' ? 'in' : 'notIn'),
              q: {
                model: 'clu_dependente',
                field: { clu_principal: null },
                where: { aAnd: [
                  { f: 'id_pac', o: '=', v: '34' },
                  { f: 'status', o: '=', v: '1' }
                ] }
              }
            }
            break

          case 'certificado':
            // VERIFICA SE TEM QUE GERAR O VALOR
            if ([ '', null, undefined ].indexOf(where.v._dataIni) !== -1) {
              where.v._dataIni = moment(where.v.dataIni, 'DD/MM/YYYY').format('YYYY-MM-DD')
            }
            if ([ '', null, undefined ].indexOf(where.v._dataFim) !== -1) {
              where.v._dataFim = moment(where.v.dataFim, 'DD/MM/YYYY').format('YYYY-MM-DD')
            }

            // SETA O WHERE QUE DEVE REALIZAR
            if (where.o === '=') {
              retorno.where = { aAnd: [
                { m: 'cliente_rotinafacil', f: 'cda1_val', o: '>=', v: where.v._dataIni + ' 00:00:00' },
                { m: 'cliente_rotinafacil', f: 'cda1_val', o: '<=', v: where.v._dataFim + ' 23:59:59' }
              ] }
            } else if (where.o === '<>') {
              retorno.where = { aOr: [
                { m: 'cliente_rotinafacil', f: 'cda1_val', o: '<', v: where.v._dataIni + ' 00:00:00' },
                { m: 'cliente_rotinafacil', f: 'cda1_val', o: '>', v: where.v._dataFim + ' 23:59:59' }
              ] }
            } else if ([ '<=' ].indexOf(where.o) !== -1) {
              retorno.where = { aOr: [
                { m: 'cliente_rotinafacil', f: 'cda1_val', o: where.o, v: where.v._dataFim + ' 23:59:59' }
              ] }
            } else if ([ '>=' ].indexOf(where.o) !== -1) {
              retorno.where = { aOr: [
                { m: 'cliente_rotinafacil', f: 'cda1_val', o: '>', v: where.v._dataIni + ' 00:00:00' }
              ] }
            }
            break

          case 'contrato_dem':
          case 'contrato_lic':
            switch (where.f + '__' + where.o) {
              case 'contrato_dem__aceito':
                retorno.where = (where.v === 's' ? { aAnd: [ { m: 'cliente_rotinafacil', f: 'con_dem_data', o: 'isNotNull' }, { m: 'cliente_rotinafacil', f: 'con_lic_data', o: 'isNull' } ] } : { m: 'cliente_rotinafacil', f: 'con_dem_data', o: 'isNull' })
                
                // (where.v === 's' ? { aAnd: [ { m: 'cliente_rotinafacil', f: 'con_dem_data', o: 'isNotNull' }, { m: 'cliente_rotinafacil', f: 'con_dem_data', o: '<>', v: '' }, { m: 'cliente_rotinafacil', f: 'con_lic_data', o: 'isNull' } ] } : { aOr: [ { m: 'cliente_rotinafacil', f: 'con_dem_data', o: 'isNull' }, { m: 'cliente_rotinafacil', f: 'con_dem_data', o: '=', v: '' } ] })
                break

              case 'contrato_lic__aceito':
                retorno.where = (where.v === 's' ? { m: 'cliente_rotinafacil', f: 'con_lic_data', o: 'isNotNull' } : { m: 'cliente_rotinafacil', f: 'con_lic_data', o: 'isNull' })
                // (where.v === 's' ? { aAnd: [ { m: 'cliente_rotinafacil', f: 'con_lic_data', o: 'isNotNull' }, { m: 'cliente_rotinafacil', f: 'con_lic_data', o: '<>', v: '' } ] } : { aOr: [ { m: 'cliente_rotinafacil', f: 'con_lic_data', o: 'isNull' }, { m: 'cliente_rotinafacil', f: 'con_lic_data', o: '=', v: '' } ] })
                break
            }
            break

          case 'tp_contrato':
            retorno.where = { f: 'id_pac', o: 'in', v: where.v }
            break

          case 'habilitada':
            switch (where.v) {
              case 'h':
                retorno.where = { m: 'cliente_rotinafacil', f: 'habilitada', o: '=', v: '1' }
                break

              case 'b':
                retorno.where = { m: 'cliente_rotinafacil', f: 'habilitada', o: '=', v: '0' }
                break

              case 'c':
                retorno.where = { m: 'cliente_rotinafacil', f: 'habilitada', o: '=', v: '2' }
                break
            }
            break

          default:
            retorno.where = { m: 'cliente_rotinafacil', f: where.f, o: where.o, v: where.v }
            break
        }

        // RETORNA O VALOR MONTADO
        return retorno
      },
      contadorGerTabSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      contadorGerTabReiniciar: function (tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && [ '', null, undefined ].indexOf(this.$refs.tabela.cpntTabelaReiniciar) === -1) {
            this.$refs.tabela.cpntTabelaReiniciar()
          } else {
            setTimeout(() => { this.contadorGerTabReiniciar((tentativa + 1)) }, 100)
          }
        }
      },
      contadorGerTabSetarFiltros: function (callback, filtros, tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.filtros) === -1 && [ '', null, undefined ].indexOf(this.$refs.filtros.cpntFiltroSetarFiltros) === -1) {
            this.$refs.filtros.cpntFiltroSetarFiltros(callback, filtros)
          } else {
            setTimeout(() => { this.contadorGerTabSetarFiltros(callback, filtros, (tentativa + 1)) }, 100)
          }
        }
      },
      contadorGerTabMontarFiltros: function (callback, tentativa = 0, finalizaErro = false) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.filtros) === -1 && [ '', null, undefined ].indexOf(this.$refs.filtros.cpntFiltrosMontar) === -1) {
            this.$refs.filtros.cpntFiltrosMontar(callback)
          } else {
            setTimeout(() => { this.contadorGerTabMontarFiltros(callback, (tentativa + 1), finalizaErro) }, 100)
          }
        } else if (finalizaErro === true) {
          callback([])
        }
      },
      contadorGerTabSetarLinhas: function (vetor) {
        // SETA OS IDS SOLICITADOS
        for (var index in vetor) {
          // INICIA O VETOR DA LOGOTIPO
          vetor[index].logo = process.env.VUE_APP_S3_URI + process.env.VUE_APP_BUCKET_RF + '/img_cli/nao_encontrada.png'

          // VERIFICA SE TEM LOGOTIPO INSERIDA
          if ([ '', null, undefined ].indexOf(vetor[index].cod_img) === -1 && [ '', null, undefined, '0' ].indexOf(vetor[index].v_img) === -1) {
            vetor[index].logo = process.env.VUE_APP_S3_URI + process.env.VUE_APP_BUCKET_RF + '/img_cli/' + vetor[index].cod_img + '.png?v=' + vetor[index].v_img
          }

          // INICIA A VARIAVEL DO CERTIFICADO
          vetor[index].certificado = ''
          vetor[index].certificado_diff = ''

          // VERIFICA SE TEM CERTIFICADO DIGITAL
          if ([ '', null, undefined ].indexOf(vetor[index].cda1_val) === -1) {
            // CONVERTE A DATA DO BLOQUEIO
            var certificado = moment(vetor[index].cda1_val, 'YYYY-MM-DD HH:mm:ss')
  
            // CALCULA A DIFERENÇA DAS DATAS
            vetor[index].certificado_diff = certificado.diff(moment(this.$store.state.dadosApi.datetime, 'YYYY-MM-DD HH:mm:ss'), 'days')
  
            // SETA A DATA FORMATADA DO CERTIFICADO
            vetor[index].certificado = certificado.format('DD/MM/YYYY HH:mm:ss')
          }

          // INICIA A VARIAVEL DO BLOQUEIO
          vetor[index].data_blok_diff = ''

          // SETA AS INFORMAÇÕES DE CADA ICONE
          if (vetor[index].habilitada === '0') {
            // CONVERTE A DATA DO BLOQUEIO
            var bloqueio = moment(vetor[index].data_blok.split(' ')[0], 'YYYY-MM-DD')

            // CALCULA A DIFERENÇA DAS DATAS
            vetor[index].data_blok_diff = bloqueio.diff(moment(this.$store.state.dadosApi.dataAtual, 'DD/MM/YYYY'), 'days')

            // SETA A DATA E HORA ATUALIZADA
            vetor[index].data_blok = bloqueio.format('DD/MM/YYYY')
          }
        }

        // SETA OS VALORES RECEBIDOS
        this.linha = vetor

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      contadorGerTabOnBuscarOptionsFiltroF: function (callback) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = {}

        // INICIA A VARIAVEL PARA ADICONAR A DEMANDA
        vetor.options = [
          { id: 'clu',          nome: 'CLU' },
          { slot: 'contato',    remover: [ 'id_tp_con_nome', 'telefone', 'pessoa', 'tp_con' ] },
          { id: 'tp_contrato',  nome: 'Tipo Contrato' },
          { id: 'habilitada',   nome: 'Status Habilitada' },
          // { id: 'contrato_dem', nome: 'Contrato Demonstrativo' },
          // { id: 'contrato_lic', nome: 'Contrato de Licença' },
          { id: 'certificado',  nome: 'Validade certificado' },
          { id: 'regime',       nome: 'Regime de Tributação' },
          // { id: 'contador',     nome: 'Licença de uso contador' },
        ]

        // RETORNA O VALOR MONTADO
        callback(vetor)
      },
      contadorGerTabOnBuscarOptionsFiltroO: function (callback, valor) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = { tipo: 'select', disabled: false }

        // VERIFICA OS OPTIONS QUE DEVE COLOCAR
        switch (valor.f) {
          case 'clu':
          case 'contador':
          case 'habilitada':
          case 'regime':
          case 'tp_contrato':
            // SETA O OPTION DO SELETOR
            vetor.options = [
              { id: '=',    nome: '= Igual', _formatar: [ 'id' ] },
            ]

            break

          case 'contrato_dem':
          case 'contrato_lic':
            // SETA O OPTION DO SELETOR
            vetor.options = [
              { id: 'aceito', nome: 'Aceito' }
            ]

            break

          case 'certificado':
            // SETA O OPTION DO SELETOR
            vetor.options = [
              { id: '=',    nome: '= Igual',          _formatar: [ 'id' ] },
              { id: '<>',   nome: '<> Diferente',     _formatar: [ 'id' ] },
              { id: '>=',   nome: '>= Maior Igual',   _formatar: [ 'id' ] },
              { id: '<=',   nome: '<= Menor Igual',   _formatar: [ 'id' ] }
            ]

            // SETA O VALOR SELEICONADO
            vetor.value = '<='
            break
        }
        
        // RETORNA O VALOR MONTADO
        callback(vetor)
      },
      contadorGerTabOnBuscarOptionsFiltroV: function (callback, valor) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = { disabled: false }

        // INICIA A FUNÇÃO PARA FINALIZAR
        var finalizar = null

        // VERIFICA OS OPTIONS QUE DEVE COLOCAR
        switch (valor.f) {
          case 'clu':
            vetor = Object.assign(vetor, {
              tipo: 'input',
              value: ''
            })
            break

          case 'contador':
            vetor = Object.assign(vetor, {
              tipo: 'select',
              value: '',
              options: [
                { id: 's', nome: 'Sim'},
                { id: 'n', nome: 'Não'}
              ]
            })
            break

          case 'regime':
            vetor = Object.assign(vetor, {
              tipo: 'select',
              value: 's',
              options: [
                { id: '1', nome: 'Simples Nacional' },
                { id: '2', nome: 'Simples Nacional – excesso de sublimite de receita bruta' },
                { id: '3', nome: 'Regime Normal' }
              ]
            })
            break

          case 'contrato_dem':
          case 'contrato_lic':
            vetor = Object.assign(vetor, {
              tipo: 'select',
              value: 's',
              options: [
                { id: 's', nome: 'Sim'},
                { id: 'n', nome: 'Não'}
              ]
            })
            break

          case 'tp_contrato':
            vetor = Object.assign(vetor, {
              tipo: 'select',
              value: '',
              options: [
                { id: '36', nome: 'Plus'},
                { id: '34', nome: 'Free'}
              ]
            })
            break

          case 'habilitada':
            vetor = Object.assign(vetor, {
              tipo: 'select',
              value: 'h',
              options: [
                { id: 'h', nome: 'Habilitada'},
                { id: 'b', nome: 'Bloqueada'},
                { id: 'c', nome: 'Cancelada'}
              ]
            })
            break

          case 'certificado':
            vetor = Object.assign(vetor, {
              tipo: 'seletor-data',
              value: '30'
            })
            break
        }
        
        // RETORNA O VALOR MONTADO
        if (finalizar === null && Object.keys(vetor).length >= 2) {
          callback(vetor)
        }
      },
      contadorGerTabFormatarCep: function (valor) {
        return valor.replace(/^(\d{2})(\d{3})(\d{3})/, '$1.$2-$3')
      },
      contadorGerTabConectarClu: function (clu) {
        this.$store.state.comunicaAPI('/contador/usu-cliente/get/' + clu, 'GET', null, (retorno) => {
          window.open(retorno.data, '_blank')
        }, this.contadorGerTabSetarStatusGeral)
      },
      contadorGerTabPacotesLDU: function (clu) {
        // SETA OS PARAMETROS PARA INICIAR
        var params = { tipo: 'DETALHES_LU', pagina: 'pacotes', clu: clu }

        // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      contadorGerTabIniciarEdicaoOnChangeValue: function (value) {
        // SETA O VALOR RECEBIDO
        this.campoEditar.value = value

        // REMOVE A MENSAGEM DE ERRO
        this.campoEditar.mensagem = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      contadorGerTabIniciarEdicaoCampo: function (vetor) {
        // INICIA O VETOR
        var linha = JSON.parse(JSON.stringify(vetor.linha))

        // INICIA O VETOR
        var campo = {}

        // VERIFICA O CAMPO QUE DEVE ABRIR
        switch (vetor.indexCV) {
          case 'email_fiscal':
            campo = {
              id: 'contador-ger-editar--' + vetor.indexCV,
              hash: vetor.hash,
              tipo: 'input',
              value: linha[vetor.indexCV]
            }
            break
        }

        // SETA OS VALORES RECEBIDOS
        campo.extra = vetor

        // SETA O VALOR INICIAL DO CAMPO
        campo.valueIni = campo.value

        // SETA O VALOR RECEBIDO NO VETOR
        this.campoEditar = Object.assign(this.campoEditar, campo)

        // SETA O FOCUS NO CAMPO
        this.contadorGerTabIniciarEdicaoFocusCampo(campo.id)
      },
      contadorGerTabIniciarEdicaoFocusCampo: function (chave, tentativa = 0) {
        if (this.$store.state.mobile === false) {
          if (tentativa <= 5) {
            if ([ '', null, undefined ].indexOf(this.$refs[chave]) === -1 && [ '', null, undefined ].indexOf(this.$refs[chave].cpntRealizarFocus) === -1) {
              this.$refs[chave].cpntRealizarFocus()
            } else {
              setTimeout(() => { this.contadorGerTabIniciarEdicaoFocusCampo(chave, (tentativa + 1)) }, 100)
            }
          }
        }
      },
      contadorGerTabEditar: function () {
        if (this.campoEditar.value !== this.campoEditar.valueIni) {
          // REMOVE O FOCUS DE QUALQUER CAMPO
          if (document.activeElement !== document.body) {
            document.activeElement.blur()
          }

          // COPIA O VETOR
          var vetor = this.campoEditar.extra

          // INICIA O VETOR
          var formData = {}

          // SETA O ID DO REGISTRO QUE ESTÁ SENDO EDITADO
          formData.clu_dependente = this.linha[vetor.indexL].clu

          // SETA O VALOR QUE DEVE ATUALIZAR
          formData[vetor.indexCV] = this.campoEditar.tipo === 'select' ? this.campoEditar.value[this.campoEditar.keyValue] : this.campoEditar.value

          // CONVERTE O VALOR PARA STRING
          formData[vetor.indexCV] = formData[vetor.indexCV].toString()

          // CONVERTE O VALOR EM LOT
          formData = { lot: [ formData ] }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/contador', 'PUT', formData, (apiSuccess) => {
            // PEGA O RETORNO RECEBIDO 
            var retorno = apiSuccess.lot[0]

            // VERIFICA O RESULTADO DA OPERAÇÃO
            switch (retorno.code) {
              case '200':
                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

                // CHAMA A FUNÇÃO PARA ATUALIZAR A TABELA
                this.contadorGerTabBuscarLinhas()
                break

              default:
                // PEGA A MENSAGEM RETORNADA
                var mensagem = []

                // VERIFICA SE É UM VETOR NA MENSAGEM
                if (typeof retorno.message === 'object') {
                  for (var indexR in retorno.message) {
                    mensagem.push(indexR + ' - ' + (typeof retorno.message[indexR] === 'string' ? retorno.message[indexR] : retorno.message[indexR].join(' ')))
                  }
                } else {
                  mensagem.push(retorno.message)
                }

                // SETA OS DADOS RECEBIDOS NO CAMPO
                this.campoEditar.mensagem = mensagem.join('<br/>')

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()
                break
            }
          }, this.contadorGerTabSetarStatusGeral)
        }
      },
      contadorGerGerarCadastro: function (forcar = 'n') {
        // SETA O STATUS DO CAMPO
        this.novoCNPJStatus = 'carregando'
  
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // INICIA O FORMULARIO
        var formData = {}
        var method = ''
        var tipo = ''

        // VERIFICA SE TEM REATIVAÇÃO
        if (this.dialogReativar === '') {
          // SETA O METHOD
          method = 'POST'

          // SETA O CNPJ DA NOVA LICENÇA
          formData.cnpj_nova_clu = this.campos.cnpj.value
  
          // SETA O PARAMETRO PARA FORÇAR NOVA CLU
          if (forcar === 's') {
            // SETA O FLAG PARA FORÇAR A CRIAÇÃO
            formData.forcar_nova_clu = forcar
  
            // LIMPA A DIALOG DA TELA
            this.dialogNovoCNPJ = ''
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }

        } else {
          // SETA O METHOD
          method = 'PUT'

          // SETA O CNPJ DA NOVA LICENÇA
          formData.clu_adicional_reativar = this.dialogReativar

          // SETA QUE DEVE REALIZAR A REATIVAÇÃO
          tipo = 'reativar_ok'
        }
        
        // SETA A SENHA DO USUARIO QUE ESTÁ CRIANDO
        formData.senha_usuario = this.campos.senha.value

        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        this.$store.state.comunicaAPI('/contador/plus', method, formData, (retorno) => {
          // APRESENTA A MENSAGEM DE SUCESSO
          this.$store.state.TRATAR_RET_LOT_API(retorno)

          // CHAMA A FUNÇÃO PARA CONECTAR NA LICENÇA DE USO
          if (this.dialogReativar === '') {
            setTimeout(() => { this.contadorGerTabConectarClu(retorno.ref.cluNova) }, 0)
          }

          // INICIA O CARREGAMENTO DA TELA
          setTimeout(() => { this.contadorGerAbrirFiltros(tipo) }, 0)
        }, (apiError) => {
          // SETA O STATUS DO CAMPO
          this.novoCNPJStatus = apiError
    
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }, (apiValid, apiStatus) => {
          if ([ '', null, undefined ].indexOf(apiValid.cnpj_reativar_clu) === -1) {
            // SETA A MENSAGEM RECEBIDA
            this.dialogNovoCNPJ = apiValid.cnpj_reativar_clu

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          } else {
            // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
            const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API
    
            // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
            FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this, true)

            // SETA O STATUS DO CAMPO
            this.novoCNPJStatus = ''
      
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }
        })
      },
      contadorGerTabOnRemoverConta: function (clu) {
        if (window.confirm('Confirma a remoção da Licença de Uso ' + clu + '?')) {
          // INICIA O FORMULARIO
          var formData = {}
  
          // SETA A CLU QUE DEVE REMOVER
          formData.clu_adicional_remover = clu.toString()
  
          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/contador/plus', 'DELETE', formData, (retorno) => {
            // APRESENTA A MENSAGEM DE SUCESSO
            this.$store.state.TRATAR_RET_LOT_API(retorno)
  
            // INICIA O CARREGAMENTO DA TELA
            setTimeout(() => { this.contadorGerTabBuscarLinhas() }, 0)
          }, this.contadorGerTabSetarStatusGeral, (apiValid, apiStatus) => {
            // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
            const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API
    
            // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
            FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, {}, this, true)
          })
        }
      },
      contadorGerTabOnDialogReativarConta: function (linha) {
        // MANDA ABRIR A TELA DE REATIVAÇÃO
        this.dialogReativar = linha.clu
        this.novoCNPJ = true

        // SETA O FOCUS NO CAMPO
        this.contadorGerSetaFocusCampo('senha')
        
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      // contadorGerTabOnReativarConta: function (clu) {
      //   if (window.confirm('Confirma a reativação da Licença de Uso ' + clu + '?')) {
      //     // INICIA O FORMULARIO
      //     var formData = {}
  
      //     // SETA A CLU QUE DEVE REMOVER
      //     formData.clu_adicional_reativar = clu.toString()
  
      //     // CHAMA FUNÇÃO PARA COMUNICAR COM API
      //     this.$store.state.comunicaAPI('/contador/plus', 'PUT', formData, (retorno) => {
      //       // APRESENTA A MENSAGEM DE SUCESSO
      //       this.$store.state.TRATAR_RET_LOT_API(retorno)
  
      //       // INICIA O CARREGAMENTO DA TELA
      //       setTimeout(() => { this.contadorGerTabBuscarLinhas() }, 0)
      //     }, this.contadorGerTabSetarStatusGeral, (apiValid, apiStatus) => {
      //       // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
      //       const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API
    
      //       // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
      //       FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, {}, this, true)
      //     })
      //   }
      // },
      contadorGerNovoCNPJ: function () {
        // VERIFICA SE DEVE MOSTRAR A NOVA DIALOG OU NÃO
        this.novoCNPJ = !this.novoCNPJ

        // LIMPA O VALOR DO CAMPO
        this.campos.cnpj.value = ''
        this.campos.senha.value = ''
        this.novoCNPJStatus = ''
        this.dialogNovoCNPJ = ''
        this.dialogReativar = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // CHAMA A FUNÇÃO PARA SETAR O FOCUS NO CAMPO
        if (this.novoCNPJ === true) {
          this.contadorGerSetaFocusCampo('cnpj')
        }
      },
      contadorGerSetaFocusCampo: function (campo, tentativa = 0) {
        if (tentativa <= 10) {
          // SETA A FUNÇÃO DE REINICIAR
          var reiniciar = () => { setTimeout(() => { this.contadorGerSetaFocusCampo(campo, (tentativa + 1)) }, 100) }

          // PEGA O ELEMENTO QUE DEVE DAR FOCUS
          var elemento = Array.isArray(this.$refs[campo]) === true ? this.$refs[campo][0] : this.$refs[campo]

          // VERIFICA SE O ELEMENTO EXISTE
          if ([ '', null, undefined ].indexOf(elemento) === -1 && [ '', null, undefined ].indexOf(elemento.cpntRealizarFocus) === -1 && typeof elemento.cpntRealizarFocus === 'function') {
            elemento.cpntRealizarFocus()
          } else {
            reiniciar()
          }
        }
      },
      contadorGerAbrirFiltros: function (tipo) {        
        // INICIA A VARIAVEL
        var filtros = []
        var callback = null

        // VERIFICA AÇÃO QUE DEVE REALIZAR
        switch (tipo) {
          case 'reativar':
            // ADICONA OS FILTROS QUE DEVE SELECIOANR
            filtros.push({ f: 'cnpj', o: '=', v: this.campos.cnpj.value })
    
            // ADICONA OS FILTROS QUE DEVE SELECIOANR
            filtros.push({ f: 'tp_contrato', o: '=', v: '36' })
    
            // ADICONA OS FILTROS QUE DEVE SELECIOANR
            filtros.push({ f: 'habilitada', o: '=', v: 'c' })

            // SETA O CALLBACK QUE DEVE CHAMAR
            callback = () => { this.contadorGerNovoCNPJ() }
            break

          case 'reativar_ok':
            // ADICONA OS FILTROS QUE DEVE SELECIOANR
            filtros.push({ f: 'clu', o: '=', v: this.dialogReativar })

            // SETA O CALLBACK QUE DEVE CHAMAR
            callback = () => { this.contadorGerNovoCNPJ() }
            break
            
          case '':
            callback = () => { this.contadorGerNovoCNPJ() }
            break
        }

        // SETA OS FILTROS DESEJADOS
        this.contadorGerTabSetarFiltros(() => {
          // INICIA O CARREGAMENTO DA TELA
          this.contadorGerTabBuscarLinhas()

          // EXECUTA O CALLBACK RECEBIDO
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        }, filtros)
      }
    }
  }
</script>
